import TicketsScannerTicketItems from './TicketItems'

const TicketsScannerGroupedTicketItems = ({ groupedTicketItems }) => {
  const items = groupedTicketItems.map((group) => (
    <div className="col-md-6" key={group.type}>
      <h4>{group.type}</h4>
      <TicketsScannerTicketItems ticketItems={group.items} />
    </div>
  ))

  return <div>{items}</div>
}

export default TicketsScannerGroupedTicketItems
